<template>
  <div class="navbar">
    <div class="navbar__left">
      <div class="hamburger-container" @click="toggleSideBar()">
        <i :class="sidebar.opened ? 'el-icon-s-fold' : 'el-icon-s-unfold'"/>
      </div>
      <breadcrumb class="breadcrumb-container"/>
    </div>

    <div class="navbar__right">
      <div class="navbar__actions">
        <button class="nav-action" type="button" @click="skipToTenxunCoord">
          <i class="el-icon-location-outline"/>
          <span>坐标拾取</span>
        </button>
        <button class="nav-action" type="button" @click="skipToCustomerMessage">
          <i class="el-icon-chat-line-round"/>
          <span>客户消息</span>
          <em v-if="msgTotal" class="nav-action__badge">{{ msgTotal }}</em>
        </button>
        <button class="nav-action" type="button" @click="skipToNewsMessage">
          <i class="el-icon-s-order"/>
          <span>企业下单</span>
          <em v-if="notReadNum" class="nav-action__badge">{{ notReadNum }}</em>
        </button>
        <button class="nav-action" type="button" @click="skipToLogisticsMessage">
          <i class="el-icon-truck"/>
          <span>物流下单</span>
          <em v-if="logisticsNotReadNum" class="nav-action__badge">{{ logisticsNotReadNum }}</em>
        </button>
        <theme-switcher/>
      </div>

      <el-dropdown class="user-menu" trigger="click">
        <div class="user-menu__trigger">
          <span class="user-menu__avatar">{{ userAvatar }}</span>
          <span class="user-menu__name">{{ nickname }}</span>
          <i class="el-icon-arrow-down"/>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="serverQrCodeDialog = true">客服二维码</el-dropdown-item>
          <el-dropdown-item @click.native="editDialog = true">修改密码</el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-dialog :visible.sync="serverQrCodeDialog" title="客服二维码" width="420px">
      <div
          v-loading="loading"
          element-loading-text="正在上传中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.6)"
      >
        <div class="avatar-uploader">
          <el-upload
              :action="fileBaseUrl"
              :before-upload="beforeAvatarUpload"
              :data="uploadData"
              :on-success="handleAvatarSuccess"
              :show-file-list="false"
              accept="image/*"
          >
            <img v-if="serverQrCode" :src="serverQrCode" class="avatar">
            <div v-else class="avatar-uploader__placeholder">
              <i class="el-icon-plus"/>
              <span>上传二维码</span>
            </div>
          </el-upload>
        </div>
      </div>
    </el-dialog>

    <el-dialog :fullscreen="dialogFullscreen" :visible.sync="editDialog" title="修改密码" width="440px">
      <el-form ref="editForm" :model="editForm" :rules="rules" label-width="88px">
        <el-form-item label="新密码" prop="pwd1">
          <el-input v-model="editForm.pwd1" placeholder="请输入新密码" show-password/>
        </el-form-item>
        <el-form-item label="确认密码" prop="pwd2">
          <el-input v-model="editForm.pwd2" placeholder="请再次输入密码" show-password/>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="editPost">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import Breadcrumb from '@/components/Breadcrumb/index'
  import {logout} from "@/api/login/logout";
  import adminChangePwd from "@/api/user/admin-controler/adminChangePwd";
  import resDispose from "@/mixin/resDisposeMixin";
  import dialogMixin from "@/mixin/dialogMixin";
  import agencyGetNotReadMessageNum from "@/api/user/agency/agencyGetNotReadMessageNum";
  import agencyGetNotReadLogisticsMessageNum from "@/api/user/agency/agencyGetNotReadLogisticsMessageNum";
  import getAliyunOssSign from "@/api/common/getAliyunOssSign";
  import {generateUUID} from "@/utils/UUIDUtils";
  import uploadServerQRCode from "@/api/user/common/uploadServerQRCode";
  import agencyGetInfo from "@/api/user/agency/agencyGetInfo";
  import ThemeSwitcher from '@/components/ThemeSwitcher/index.vue'
  import {preserveThemeOnStorageClear} from '@/utils/theme'

  export default {
  components: {Breadcrumb, ThemeSwitcher},
  mixins: [resDispose, dialogMixin],
  computed: {
    ...mapGetters(['sidebar','msgTotal']),
    nickname() {
      const userinfo = JSON.parse(localStorage.getItem('userinfo') || '{}')
      return userinfo.nickname || '代理商'
    },
    userAvatar() {
      return (this.nickname || '代').slice(0, 1)
    },
  },
  data() {
    return {
      loading: false,
      uploadData:{},
      fileBaseUrl: process.env.VUE_APP_FILE_BASE_URL,
      serverQrCode:JSON.parse(localStorage.getItem('userinfo')).serverQrCode ? process.env.VUE_APP_FILE_BASE_URL+JSON.parse(localStorage.getItem('userinfo')).serverQrCode : '',
      serverQrCodeDialog: false,

      notReadNum: 0,
      logisticsNotReadNum: 0,
      editDialog: false,
      editForm: {
        pwd1: undefined,
        pwd2: undefined
      },
      rules: {
        pwd1: [
          {required: true, message: '请输入密码'},
        ],
        pwd2: {
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请再次输入密码'))
            } else if (value !== this.editForm.pwd1) {
              callback(new Error('两次输入密码不一致!'))
            } else {
              callback()
            }
          }
        }
      },
      show: true
    }
  },
  mounted() {
    let timer = setInterval(()=>{
      agencyGetNotReadMessageNum().then(res=>{
        this.notReadNum=res.data
      }).catch(()=>{
        clearInterval(timer)
      })
      agencyGetNotReadLogisticsMessageNum().then(res=>{
        this.logisticsNotReadNum=res.data
      }).catch(()=>{
        clearInterval(timer)
      })
    },10000)
  },
  watch: {
    $route: {
      handler: function (val) {
        if (val.name === "企业下单") {
          this.show = true;
        }
      },
      deep: true
    }
  },
  methods: {
    skipToTenxunCoord(){
      const myWindow = window.open("", "_blank");
      myWindow.location.href = "https://lbs.qq.com/getPoint/"
    },
    skipToCustomerMessage() {
      if (this.$route.name !== "客户消息") {
        this.$router.push({name: "客户消息"})
      }
    },
    skipToNewsMessage() {
      if (this.$route.name !== "企业下单") {
        localStorage.removeItem("newsId")
        localStorage.setItem("promulgatorId","0")
        this.$router.push({name: "企业下单"})
      }
    },
    skipToLogisticsMessage() {
      if (this.$route.name !== "物流下单") {
        localStorage.removeItem("positionId")
        localStorage.setItem("promulgatorId","0")
        this.$router.push({name: "物流下单"})
      }
    },
    async beforeAvatarUpload() {
      await getAliyunOssSign("/common/sign").then(response => {
        let resultObj = response.data;
        this.uploadData.policy = resultObj.policy;
        this.uploadData.signature = resultObj.signature;
        this.uploadData.ossaccessKeyId = resultObj.accessid;
        this.uploadData.key = resultObj.dir + '/' + generateUUID() + '_${filename}';
        this.uploadData.dir = resultObj.dir;
        this.uploadData.host = resultObj.host;
      });
      return true
    },
    async handleAvatarSuccess(response, file) {
      this.loading = true
      const filename = this.uploadData.key.replace("${filename}",file.name)
      await uploadServerQRCode({qrCode:filename}).then(res=>{
        if (res.code===1){
          agencyGetInfo().then(res=>{
            localStorage.setItem('userinfo',JSON.stringify(res.data))
            this.serverQrCode = this.fileBaseUrl+JSON.parse(localStorage.getItem('userinfo')).serverQrCode
          })
        }
      })
      this.loading = false
    },
    editPost() {
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          adminChangePwd({pwd: this.editForm.pwd1}).then(res => {
            this.resDispose({
                  res,
                  success: () => {
                    this.editDialog = false;
                  }
                },
            )
          })
        }
      });
    },
    ...mapActions({
      logout_login: 'logout',
    }),
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    logout() {
      preserveThemeOnStorageClear()
      logout().then(res => {
        this.resDispose({
          res, success: () => {
            this.logout_login();
            this.$router.push(`/login?redirect=${this.$route.fullPath}`)
          }
        })
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  padding: 0 20px 0 0;
  background: var(--app-navbar-bg);
  box-shadow: 0 1px 0 var(--app-navbar-border);
  transition: background-color 0.25s ease, box-shadow 0.25s ease;

  &__left {
    display: flex;
    align-items: center;
    min-width: 0;
  }

  &__right {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 4px;
  }
}

.hamburger-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  cursor: pointer;
  color: var(--app-nav-action-color);
  transition: background 0.2s, color 0.2s;

  i {
    font-size: 20px;
  }

  &:hover {
    background: var(--app-nav-action-hover-bg);
    color: var(--app-nav-action-hover-color);
  }
}

.breadcrumb-container {
  margin-left: 4px;
}

.nav-action {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 12px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--app-nav-action-color);
  font-size: 13px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  white-space: nowrap;

  i {
    font-size: 16px;
    color: var(--app-text-secondary);
  }

  &:hover {
    background: var(--app-nav-action-hover-bg);
    color: var(--app-nav-action-hover-color);

    i {
      color: var(--app-nav-action-hover-color);
    }
  }

  &__badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 18px;
    height: 18px;
    padding: 0 5px;
    border-radius: 9px;
    background: #ff4d4f;
    color: #fff;
    font-style: normal;
    font-size: 11px;
    font-weight: 600;
    line-height: 1;
  }
}

.user-menu {
  &__trigger {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 8px 4px 4px;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
      background: var(--app-nav-action-hover-bg);
    }
  }

  &__avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: linear-gradient(135deg, var(--app-primary), var(--app-primary-light));
    color: #fff;
    font-size: 14px;
    font-weight: 600;
  }

  &__name {
    font-size: 14px;
    color: var(--app-text-primary);
    font-weight: 500;
  }

  .el-icon-arrow-down {
    font-size: 12px;
    color: #9ca3af;
  }
}

.avatar-uploader {
  display: flex;
  justify-content: center;

  &__placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 160px;
    height: 160px;
    border: 1px dashed #d9d9d9;
    border-radius: 12px;
    color: #9ca3af;
    transition: border-color 0.2s;

    i {
      font-size: 28px;
      margin-bottom: 8px;
    }

    span {
      font-size: 13px;
    }
  }

  .el-upload:hover .avatar-uploader__placeholder {
    border-color: #1677ff;
    color: #1677ff;
  }

  .avatar {
    width: 160px;
    height: 160px;
    object-fit: contain;
    border-radius: 12px;
    border: 1px solid #f0f2f5;
  }
}

@media (max-width: 1200px) {
  .nav-action span:not(.nav-action__badge) {
    display: none;
  }

  .nav-action {
    padding: 0 10px;
  }
}
</style>
